import { useSelector } from 'react-redux';
import core, { App } from '@gin-betting/core';
import { createStructuredSelector } from 'reselect';

import { useWithLocation } from 'hooks';
import type { State } from 'types';
import { checkIsDynamicCategorizer, parse } from 'utils';

const {
    utils: { getBettingOptions, isOneOfPages, getAppliedFilters },
    viewport: {
        selectors: { selectIsCompact },
    },
} = core;

interface Output {
    withSportNavigation: boolean;
    isCompact: boolean;
    isBettingPage: boolean;
    withRender: boolean;
    withFilters: boolean;
}

export default function useMatchListNavigation(): Output {
    const {
        withSportNavigation,
        withRender,
        location,
        withFilters,
    } = useWithLocation(l => {
        const { freeBetId } = getAppliedFilters();

        const { isTop } = parse(l.search);

        return {
            withSportNavigation: !checkIsDynamicCategorizer(),
            withRender:
                isOneOfPages(
                    [
                        App.Routes.UPCOMING_LIST,
                        App.Routes.ESPORT,
                        App.Routes.CLASSIC,
                        App.Routes.RESULTS_LIST,
                    ],
                    { exact: true }
                ) || isOneOfPages([App.Routes.LIVE_LIST, App.Routes.PREMATCH]),
            location: l,
            withFilters:
                !isOneOfPages([App.Routes.OUTRIGHTS_LIST]) &&
                !freeBetId &&
                !isTop,
        };
    });

    const { isCompact } = useSelector((s: State) =>
        selectProps(s, { location })
    );

    return {
        withSportNavigation,
        isCompact,
        isBettingPage: getBettingOptions().url.pagePath === '',

        withRender,
        withFilters,
    };
}

const selectProps = createStructuredSelector({
    isCompact: selectIsCompact,
});
